import { ICellRendererParams } from "ag-grid-community";
import startCase from "lodash.startcase";
import { DateTime } from "luxon";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  OrganizationSummarySubscriptionProductDto,
  StripeSubscriptionStatus,
} from "@intelligems/ig-types";
import { Grid, Skeleton, useTheme } from "@mui/material";

const Text: Partial<Record<StripeSubscriptionStatus, string>> = {
  cancelled: "Cancelled",
  canceled: "Cancelled",
};

export const StatusColumn = (
  params: ICellRendererParams<OrganizationSummarySubscriptionProductDto>
) => {
  const theme = useTheme();

  const Color: Partial<Record<StripeSubscriptionStatus, string>> = {
    active: theme.igIconColors.success,
    pending: theme.igIconColors.warning,
    cancelled: theme.igIconColors.error,
    trialing: theme.igIconColors.info,
    past_due: theme.igIconColors.error,
  };

  if (!params.data) {
    return null;
  }

  const status = params.data.status;
  const cancelAt = params.data.cancelAt;

  return (
    <Grid
      container
      item
      alignItems={"center"}
      columnSpacing={1}
      flexWrap={"nowrap"}
    >
      <Grid item>
        <Skeleton
          variant="circular"
          animation={false}
          sx={{
            alignSelf: "center",
            height: "6px",
            width: "6px",
            backgroundColor:
              Color[cancelAt ? "cancelled" : status] ||
              theme.igIconColors.light,
          }}
        />
      </Grid>
      <Grid item>
        <IgTypography variant={"body2"}>
          {cancelAt
            ? `Pending Cancellation ${DateTime.fromSeconds(cancelAt).toFormat("MM/dd/yyyy")}`
            : Text[status] || startCase(status)}
        </IgTypography>
      </Grid>
    </Grid>
  );
};
